module.exports = __webpack_public_path__ + "static/media/28-8.27f59d9b.mp3";